const { CardDeck, MilitaryCardTypes } = require("../../Constants/Names/CardTypes");
const { Age } = require('../../Constants/Constants');
const Card = require("./Card");

class BonusCard extends Card {
    constructor(age){
        super(
            CardDeck.Military,
            MilitaryCardTypes.Bonus,
            null,
            "Defense/Colonization",
            age,
            `+${BonusCard.GetDefenseBonus(age)} Defense / +${BonusCard.GetColonizationBonus(age)} Colonization.`,
            {
                playerStateAltering:
                (platerState) => {
                    //do stuff
                }
            }
        )
    }

    static GetDefenseBonus(age) {
        switch (age)
        {
            default:
                return 0;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 4;
            case Age.Age3:
                return 6;
        }
    }

    static GetColonizationBonus(age) {
        switch (age)
        {
            default:
                return 0;
            case Age.Age1:
                return 1;
            case Age.Age2:
                return 2;
            case Age.Age3:
                return 3;
        }
    }
}

module.exports = BonusCard;